<template>
  <div
    class="home w-full px-36 py-8 float-left flex justify-center items-center"
  >
    <div
      class="max-w-fix w-full flex flex-row float-left gap-14"
      style="max-width: 1248px"
    >
      <div class="w-3/5 py-9 px-10 float-left shadow rounded-lg">
        <div class="flex flex-col gap-4 w-full float-left">
          <div class="w-full float-left">
            <h1 class="text-left text-lg font-medium text-black">
              {{ $t("place-order.title") }}
            </h1>
            <h2 class="text-left text-sm text-gray">
              {{ $t("place-order.sub-title") }}
            </h2>
          </div>
          <div class="w-full float-left input">
            <label for="destination">{{ $t("place-order.destination") }}</label>
            <SelectInput :options="cities" @input="selectedCity = $event" />
          </div>
          <div class="w-full float-left input">
            <label for="timeDate">{{ $t("place-order.time-date") }}</label>
            <TimeSelectInput @input="selectedTime = $event" />
          </div>
          <div class="w-full float-left input">
            <label for="comments">{{ $t("place-order.comments") }}</label>
            <input
              name="comments"
              type="text"
              autocomplete="off"
              :placeholder="$t('place-order.enter-comments')"
            />
          </div>
          <div class="w-full float-left input">
            <label>{{ $t("place-order.car-type") }}</label>
            <RadioGroup :options="cars" @input="selectedCar = $event" />
          </div>
          <div class="w-full float-left input">
            <label>{{ $t("place-order.number-of-bags") }}</label>
            <RadioGroup
              :rounded="true"
              :options="[
                { title: 0 },
                { title: 1 },
                { title: 2 },
                { title: 3 },
                { title: 4 },
                { title: 5 },
                { title: 6 },
                { title: 7 },
              ]"
              @input="numberOfBagages = $event"
            />
          </div>
          <div class="w-full float-left input">
            <label>{{ $t("place-order.language") }}</label>
            <RadioGroup :options="langs" @input="selectedLang = $event" />
          </div>
          <div class="w-full float-left input">
            <label>{{ $t("place-order.constraints") }}</label>
            <CheckBoxesGroup
              :options="constraints"
              @input="selectedConstraints = $event"
            />
          </div>
          <div class="w-full float-left input">
            <label>{{ $t("place-order.payment") }}</label>
            <RadioGroup
              :options="paymentMethods"
              @input="selectedPaymentMethod = $event"
            />
          </div>
          <div class="w-full float-left">
            <button class="mt-8 float-right">
              {{ $t("place-order.send-orders") }}
            </button>
          </div>
        </div>
      </div>
      <a @click="logout" class="float-left">Logout from company account</a>
    </div>
  </div>
</template>

<script>
import SelectInput from "@/components/SelectInput.vue";
import TimeSelectInput from "@/components/TimeSelectInput.vue";
import RadioGroup from "@/components/RadioGroup.vue";
import CheckBoxesGroup from "@/components/CheckBoxesGroup.vue";

export default {
  name: "CompanyPlaceOrder",
  title: "Dashboard",
  components: {
    SelectInput,
    TimeSelectInput,
    RadioGroup,
    CheckBoxesGroup,
  },
  data() {
    return {
      selectedCity: "",
      selectedTime: "",
      cars: [],
      selectedCar: "",
      numberOfBagages: 0,
      langs: [],
      selectedLang: "",
      constraints: [],
      selectedConstraints: [],
      paymentMethods: [],
      selectedPaymentMethod: "",
    };
  },
  created() {
    this.loadLanguages();
    this.loadCars();
    this.loadConstraints();
    this.loadPaymentMethod();
  },
  methods: {
    logout() {
      this.$store.dispatch("destroyToken").then(() => {
        this.$router.push({ name: "Login" });
      });
    },
    loadLanguages() {
      this.langs = [
        { title: this.$t("place-order.languages.english"), img: "en.svg" },
        { title: this.$t("place-order.languages.french"), img: "fr.svg" },
        { title: this.$t("place-order.languages.italian"), img: "it.svg" },
      ];
    },
    loadCars() {
      this.cars = [
        { title: "Voiture", img: "taxi.svg" },
        { title: "Monospace", img: "monospace.svg" },
        { title: "Bus", img: "bus.svg" },
      ];
    },
    loadConstraints() {
      this.constraints = [
        { title: "Animal", img: "animal.svg" },
        { title: "Fauteil roulant", img: "wheelchair.svg" },
      ];
    },
    loadPaymentMethod() {
      this.paymentMethods = [
        { title: "Cash", img: "cash.svg" },
        { title: "Credit Card", img: "credit_card.svg" },
      ];
    },
  },
  watch: {
    "$i18n.locale": function () {
      this.loadLanguages();
    },
  },
};
</script>

<style lang="scss" scoped>
.input {
  label {
    text-align: left;
    color: #788e98;
    float: left;
    font-size: 14px;
    padding-bottom: 6px;
  }

  input {
    float: left;
    width: 100%;
    max-width: none;
  }
}

button {
  max-width: 200px;
}
</style>
